import { connect } from 'react-redux'
import NumbersSummaryStep from './NumbersSummaryStep'
import { get } from 'lodash'

const getCmsProduct = (cms, numberType, productId) => {
  if (numberType === '1300') {
    return get(
      cms.product1300Plans.find(item => item.fields.id === productId),
      'fields',
      {}
    )
  } else if (numberType === '1800') {
    return get(
      cms.product1800Plans.find(item => item.fields.id === productId),
      'fields',
      {}
    )
  } else if (numberType === 'local') {
    return get(
      cms.productTwilioPlans.find(item => item.fields.id === 'local'),
      'fields',
      {}
    )
  }
  return {}
}

const stateToProps = ({ cms, numbers }, { formData, numberType }) => ({
  product: getCmsProduct(cms, numberType, formData.productId),
  submitting: numbers.numbersCreateLoading,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(NumbersSummaryStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersSummaryStep/NumbersSummaryStep.container.js